export type FeatureFlag = Record<string, boolean>

export const isFeatureEnabled = (
  feature: string,
  featureFlags: FeatureFlag,
) => {
  if (feature === undefined) {
    return true
  }

  if (feature === '') {
    return false
  }

  return Boolean(featureFlags[feature])
}
